import React, { Component } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Drawer } from 'antd';

import SettingsPage from './usermanagement/SettingsPage';
import Login from './login/Login';
import LoginCard from './login/LoginCard';

import Dashboard from './dashboard/Dashboard';
import Sites from './sites/Sites';
import Overview from './overview/Overview';
import Devices from './devices/Devices';
import Reports from './reports/Reports';
import Finance from './finance/Finance';
import Analysis from './analysis/Analysis';

/* Components */
import SideNav from './sidenav/SideNav';

/* Other pages */
import NotFound from './otherpages/NotFound';


import './app.css';


import {
	userTimeout
} from '../modules/user';

// Scroll to top on route change
class ScrollToTopInner extends React.Component {
	componentDidUpdate(prevProps) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			window.scrollTo(0, 0);
		}
	}
	render() {
		return null;
	}
}
function ScrollToTopWrapper(props) {
	const location = useLocation();
	return <ScrollToTopInner {...props} location={location} />;
}
export const ScrollToTop = ScrollToTopWrapper;

// Protected route wrapper
const PrivateRoute = ({ component: Component, isAuthenticated, typeAccount, userRole, userSessionTimeout }) => {
	if (isAuthenticated || userSessionTimeout) {
		if (typeAccount && !typeAccount.includes(userRole)) {
			return <Navigate to="/login" />;
		}
		return <Component />;
	}
	return <Navigate to="/login" />;
};

class App extends Component {
	componentDidMount() {
		const { userTheme, userNav } = this.props;
		if (this.props.location.pathname === '/login') {
			document.body.setAttribute("data-theme", 'light');
		} else {
			document.body.setAttribute("data-theme", userTheme);
		}
		document.body.setAttribute("data-width", userNav ? 'wide' : 'narrow');
		document.addEventListener(
			"SessionExpired",
			(e) => {
				this.props.userTimeout(true);
			},
			false
		);
	}

	componentDidUpdate(prevProps) {
		const { userTheme, userNav } = this.props;
		/*
		if (this.props.location.pathname === '/login') {
			document.body.setAttribute("data-theme",'light');
		}else if(userTheme !== prevProps.userTheme){
			document.body.setAttribute("data-theme",userTheme);
		}
			*/
		if (userNav !== prevProps.userNav) {
			document.body.setAttribute("data-width", this.props.userNav ? 'wide' : 'narrow');
		}
	}


	render() {
		const { userProfile, userSessionTimeout, location, userAuthenticated } = this.props;
		var userRole = (userProfile.user) ? userProfile.user.role : null;
		var rootUrl = "/";

		var classMainContent = (location.pathname === '/login') ? 'mainContentLogin' : 'mainContent';
		return (
			<div className="App">
				{
					(location.pathname !== '/login') ?
						<div>
							<SideNav />
							<Drawer
								title="Session Expired"
								placement={`right`}
								closable={false}
								open={userSessionTimeout}
								key={`right`}
							>
								<span>Your session has expired. Please log in again to continue.</span>
								<LoginCard userSessionTimeout={true} />
							</Drawer>
						</div>
						:
						""
				}

				<ScrollToTop />
				<div className={classMainContent} >
					<Routes>
						<Route path="/login" element={<Login />} />
						<Route exact path="/" element={<PrivateRoute component={Dashboard} isAuthenticated={userAuthenticated} userSessionTimeout={userSessionTimeout} userRole={userRole} typeAccount={['superadmin']} />} />
						<Route exact path="/sites" element={<PrivateRoute component={Sites} isAuthenticated={userAuthenticated} userSessionTimeout={userSessionTimeout} userRole={userRole} typeAccount={['superadmin']} />} />
						<Route exact path="/devices" element={<PrivateRoute component={Devices} isAuthenticated={userAuthenticated} userSessionTimeout={userSessionTimeout} userRole={userRole} typeAccount={['superadmin']} />} />
						<Route exact path="/reports" element={<PrivateRoute component={Reports} isAuthenticated={userAuthenticated} userSessionTimeout={userSessionTimeout} userRole={userRole} typeAccount={['superadmin']} />} />
						<Route exact path="/finance" element={<PrivateRoute component={Finance} isAuthenticated={userAuthenticated} userSessionTimeout={userSessionTimeout} userRole={userRole} typeAccount={['superadmin']} />} />
						<Route exact path="/analysis" element={<PrivateRoute component={Analysis} isAuthenticated={userAuthenticated} userSessionTimeout={userSessionTimeout} userRole={userRole} typeAccount={['superadmin']} />} />
						<Route exact path="/settings" element={<PrivateRoute component={SettingsPage} isAuthenticated={userAuthenticated} userSessionTimeout={userSessionTimeout} userRole={userRole} typeAccount={['superadmin']} />} />
						<Route path="*" element={<NotFound />} />
					</Routes>
				</div>
			</div>
		);
	}
}

function AppWithLocation(props) {
	const location = useLocation();
	return <App {...props} location={location} />;
}


const mapStateToProps = state => ({
	userAuthenticated: state.user.userAuthenticated,
	userSessionTimeout: state.user.userSessionTimeout,
	userProfile: state.user.userProfile,
	userTheme: state.user.userTheme,
	userNav: state.user.userNav
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userTimeout
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AppWithLocation);
